// @flow
// $FlowFixMe
import {REHYDRATE} from 'redux-persist';
import type {StateType} from '../reducers';
import type {YourOrdersActionType} from './actions';

export const initialState: YourOrdersStateType = {hiddenDeliveryResources: []};

export default (
  state: YourOrdersStateType = initialState,
  action: YourOrdersActionType,
): YourOrdersStateType => {
  switch (action.type) {
    case 'DISMISS_DELIVERY_RESOURCE':
      return {
        ...state,
        hiddenDeliveryResources: [
          ...state.hiddenDeliveryResources,
          action.payload.ouid,
        ],
      };
    case REHYDRATE:
      if (action.payload) {
        const incoming = action.payload.yourOrders;
        if (incoming) return incoming;
      }
      return state;
    default:
      return state;
  }
};

export const hiddenDeliveryResourcesSelector = (
  state: StateType,
): Array<string> => state.yourOrders.hiddenDeliveryResources;

export type YourOrdersStateType = {
  hiddenDeliveryResources: Array<string>,
};
